import { toast } from "react-toastify";
import "../css/toastConfig.css";

const toastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showSuccessToast = (message) => {
  toast.success(message, {
    ...toastOptions,
    className: "custom-toast custom-toast-success",
  });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    ...toastOptions,
    className: "custom-toast custom-toast-error",
  });
};

export const showInfoToast = (message) => {
  toast.info(message, {
    ...toastOptions,
    className: "custom-toast custom-toast-info",
  });
};